import template from "./bAnnualSettle.html";
import moment from "moment";

export function bAnnualSettleDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: bAnnualSettleController,
    controllerAs: 'bAnnualSettle',
    bindToController: true,
    scope: {
      employeeData: "=",
      showModal: "=",
      employeeId: "=",
      employeeView: "=",
      canEdit: "=",
      isManagementView: "=?"
    },
  };

  return directive;
}

class bAnnualSettleController {
  constructor(API, Stats, Notes, bModal, $translate, $scope, $interval, $filter, $rootScope) {
    'ngInject';

    this.Notes = Notes;
    this.bModal = bModal;
    this.API = API;
    this.Stats = Stats;
    this.$translate = $translate;
    this.$filter = $filter;
    this.$scope = $scope;
    this.$interval = $interval;
    this.expiresAt = "";
    this.userSettlements = [];
    this.employeeView = false;
    this.showCreateSettlmentModal = false;
    this.userSettlement = "";
    this.$rootScope = $rootScope;
    this.data = "";
    this.employee = "";
    this.cumulatedOvertimePositive = true;

    this.$scope.$watch(() => this.$rootScope.reloadAnnualSettle, () => this.updateView());
    this.$scope.$watch(() => this.$rootScope.reloadCreateSettleView, () => this.updateView());

    this.shareHeaders = [
      { name: this.$translate.instant("OVERTIME.MODAL.DATE"), class: "table-short", sort: "year" },
      {
        name: this.$translate.instant("OVERTIME.MODAL.OVER_TIME_BALANCE"),
        class: "table-short",
        sort: "cumulatedOvertime"
      },
      { name: this.$translate.instant("OVERTIME.MODAL.ACCEPTED_TIME_BALANCE"), class: "table-short", sort: "validFrom" },
      { name: this.$translate.instant("OVERTIME.MODAL.WORKLOGS_ACCEPTED"), class: "table-short", sort: "validUntil" },
      { name: this.$translate.instant("OVERTIME.MODAL.USED_OVERTIMES"), class: "table-short" },
      { name: this.$translate.instant("OVERTIME.MODAL.COMMENT"), class: "table-short", sort: "comment" },
      { id: "actions", name: null, class: "table-actions" },
    ];
    this.state = "loading";
  }

  updateView() {
    if (this.$rootScope.reloadAnnualSettle === true || this.$rootScope.reloadCreateSettleView === true) {
      this.$rootScope.reloadAnnualSettle = false;
      this.$rootScope.reloadCreateSettleView = false;
      this.init();
    }
  }

  init() {
    var timeout = this.$interval(() => {
      this.notes = this.Notes.getNotes();
    }, 10);
    this.$scope.$on("$destroy", () => {
      this.$interval.cancel(timeout);
    });

    this.state = "loading";

    if (this.canEdit) {
      this.Stats.createSettlementView(this.employee.id, this.isManagementView).then(res => {
        this.cumulatedOvertimePositive = moment.duration(res.data.settlementCreateView.cumulatedOvertime) > 0;
      });

      this.Stats.getOvertimeSettlements(this.employee.id, this.isManagementView).then(res => {
        const userSettlements = res.data.userOvertimeSettlements.overtimeSettlementsView.map((x) => {
          return {
            ...x,
            settledOvertimeSumSort: moment.duration(x.settledOvertimeSum)._milliseconds
          };
        }).sort((a, b) => new Date(b.year) - new Date(a.year));
        this.userSettlements = userSettlements;
        this.state = "loaded";
      }, () => {
        this.state = "error";
      });
    }
    else {
      this.cumulatedOvertimePositive = undefined;
      this.Stats.getOvertimeSettlementsUser().then(res => {
        const userSettlements = res.data.userOvertimeSettlements.overtimeSettlementsView.map((x) => {
          return {
            ...x,
            settledOvertimeSumSort: moment.duration(x.settledOvertimeSum)._milliseconds
          };
        }).sort((a, b) => new Date(b.year) - new Date(a.year));
        this.userSettlements = userSettlements;
        this.state = "loaded";
      }, () => {
        this.state = "error";
      });
    }
  }

  getAcceptedBalanceEdit(x) {
    return x.acceptedBalance !== undefined ? this.$filter("hms")(x.acceptedBalance) :
      moment.duration(x.cumulatedOvertime)._milliseconds < 0 ? (moment.duration(x.cumulatedOvertime).add(1, 'seconds').toJSON()) :
        this.$filter("hms")(x.cumulatedOvertime);
  }

  setupData(data) {
    this.employee = data.employeeData;
    this.employeeView = data.employeeView;
    this.init();
  }

  closeShareModal() {
    this.$rootScope.reloadAnnualSettle = true;
    this.showModal = false;
  }

  editSettle(userSettlement) {
    this.userSettlement = userSettlement;
    this.showEditSettlmentModal = true;
  }

  deleteSettle(settlement) {

    this.modalConfig = {
      text: this.$translate.instant("VIEW360.MODAL.QUESTION_DELETE"),
      cancelText: this.$translate.instant("VIEW360.MODAL.NO"),
      acceptText: this.$translate.instant("VIEW360.MODAL.YES")
    };

    this.bModal.show(this.modalConfig).then(() => {
      this.Stats.deleteSettlement(settlement.id, this.isManagementView).then(() => {
        this.Notes.postNote({
          type: "success",
          message: this.$translate.instant("VIEW360.MODAL.SUCCESS_DELETED")
        });
        this.init();
      }, (res) => {
        this.Notes.postNote({
          type: "error",
          message: res.data
        });
      });
    }, angular.noop);
  }

  saveAnnual(annual) {
    const data = {
      userId: this.employee.id,
      year: annual.year,
      cumulatedOvertime: moment.duration(annual.cumulatedOvertime).toJSON(),
      acceptedBalance: moment.duration(annual.acceptedBalanceEdit).toJSON(),
      comment: annual.comment
    };
    this.Stats.saveAnnualSetOff(data).then(() => {
      this.Notes.postNote({
        type: "success",
        message: this.$translate.instant("VIEW360.MODAL.SUCCESS_SAVED")
      });
      annual.isEdited = false;
      this.annualObjects.map(annualObject => {
        if (annualObject.year === data.year) {
          annualObject.oldComment = data.comment;
          annualObject.secondEntry = data.acceptedBalance;
        }
      });
    }, (res) => {

      this.modalConfig = {
        text: res.data && res.data.message,
        acceptText: this.$translate.instant("OK"),
        cancelText: "",
        hideLeftButton: "hide"
      };

      this.bModal.show(this.modalConfig).then(() => {
      }, (res) => {
        this.Notes.postNote({
          type: "error",
          message: res.data
        });
      });
    }, angular.noop);
  }

  editCancel(annualObject) {
    annualObject.comment = annualObject.oldComment;
    annualObject.acceptedBalance = annualObject.oldAcceptedBalance;
    annualObject.isEdited = false;
  }

  openSettlementModal() {
    this.showCreateSettlmentModal = true;
  }

  openSettlementEditModal() {
    this.showEditSettlmentModal = true;
  }

  inputChange(annualObject) {
    if (annualObject.acceptedBalanceEdit === '0') {
      annualObject.acceptedBalanceEdit = "00:00:00";
      annualObject.durationInvalid = false;
    }
    else {
      let format = /^-?(\d+):(?:[012345]\d):(?:[012345]\d)/;
      let match = annualObject.acceptedBalanceEdit.match(format);

      if (match) { annualObject.durationInvalid = false; }
      else { annualObject.durationInvalid = true; }
    }
  }
}
